export enum OperatorPermissions {
    CLOSE_SESSION = 'FecharCaixa',
    OPEN_SESSION = 'AbrirCaixa',
    LOGOUT_SESSION = 'PermitirSairCaixa',
    ALLOW_DISCOUNT = 'PermitirDesconto',
    TRANSFER_ITEMS = 'TransferirConsumo',
}